<label
  class="tw-flex tw-items-center tw-gap-[8px] tw-cursor-pointer tw-flex-1 wo-multiselect-all-checkbox"
  [class.wo-multiselect-all-checkbox--small]="small"
  *ngIf="isVisible">
  <tui-checkbox
    [ngModel]="selected"
    [size]="small ? 'm' : 'l'"
    (ngModelChange)="onChange($event)"
  />
  All
</label>
<ng-content/>
